import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Tabs,Paper,AppBar,CssBaseline,Box,Typography,Container,ButtonGroup,Button
  ,Tab} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import {PatientActions} from '../../../redux/actions/PatientActions';
import PatientAddressInfo from './PatientAddressInfo';
import PatientBasicInfo from './PatientBasicInfo';
import PatientInsuranceInfo from './PatientInsuranceInfo';
import PatientTapPanel from './PatientTapPanel';
import PatientAppointmentHistory from '../../appointments/PatientAppointmentHistory';
import { USER_ROLE } from '../../../components/security/UserRole';
function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(4),
  },
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
});



class PatientProfile  extends React.Component {
  
  constructor(props) {
    super(props);
    const { userid } = this.props.match.params
    this.state = {
        patientId : userid,
        userid : userid,
        isNew : false,
        tabsValue : 0,
        patient:{

        },
        isLoaded :false,
        submitted: false
    };
    
}

componentDidMount() {
  if(this.state.userid && this.state.userid.length > 0){
    this.props.getUserById(this.state.userid);
    this.setState({isNew:false});
  }else if(this.props.user && this.props.user.userRole===USER_ROLE.PATIENT){
    this.setState({isNew:false});
    this.props.getUserById(this.props.user.patientId);
  }else{
    this.props.addNew();
    this.setState({isNew:true});
    this.setState({isLoaded:true});
  }
  
}

componentDidUpdate(prevProps){
  if(prevProps.patient && prevProps.patient.patientDetailsById && this.state.patient 
    && prevProps.patient.patientDetailsById.id !== this.state.patient.id){
    this.setState({patient : this.props.patient.patientDetailsById});
    this.setState({isLoaded:true});
    this.setState({isNew:false});
  }
  
  // else if(this.props.patient.registeredSuccessfully || this.props.patient.updatedSuccessfully){
  //   this.setState({patient : this.props.patient.patientDetailsById});
  //   PatientActions.updateRegistrationFlags(false);
  //   this.setState({isLoaded:true});
  // }
}

  render(){
    const handleChange = (event, newValue) => {
      this.setState({tabsValue:newValue});
    };
    
    const updateBasicInfo = (value) => {
      var patient = this.state.patient;
      if(this.state.isNew){
        patient.username = value.email;
      }
      patient.firstName = value.firstName;
      patient.lastName = value.lastName;
      patient.email = value.email;
      patient.phoneNo = value.phoneNo;
      patient.dob = value.dob;
      patient.userRole = value.userRole;
      patient.status = value.status;
      patient.emailOptOut= value.emailOptOut;
      patient.emailOptIn= value.emailOptIn;
      patient.mailAddress= value.mailAddress;
      patient.mailingOptIn= value.mailingOptIn;
      patient.mailingOptOut= value.mailingOptOut;
      patient.phoneNoOptIn= value.phoneNoOptIn;
      patient.phoneNoOptOut= value.phoneNoOptOut;
      patient.mobilePhoneNo= value.mobilePhoneNo;
      patient.mobOptIn= value.mobOptIn;
      patient.mobOptOut= value.mobOptOut;
      patient.elcNotiOptIn= value.elcNotiOptIn;
      patient.elcNotiOptOut= value.elcNotiOptOut;
      this.setState({patient :patient});
      
      if(this.state.isNew){
          this.props.submit(value);
      }else{
        this.props.update(patient);
      }
    };
    const updateAddressInfo = (value) => {
      var patient = this.state.patient;
      value.id=patient.id;
      patient.patientAddressDetails = value;
      this.setState({patient :patient});
      this.props.updateAddressInfo(value);
    };
    const updateInsurerInfo = (value) => {
      var patient = this.state.patient;
      patient.insurerInfo = value;
      value.id=patient.id;
      this.setState({patient :patient});
      this.props.updateInsuranceInfo(value);
    };
    const classes = this.props.classes;
    
    const basicInfo = this.state.isLoaded 
    ?  (<PatientBasicInfo basicinfo={this.state.patient} isNew={this.state.isNew} updateBasicInfo={(value) => {updateBasicInfo(value)}}/>):null;
    
    return (
    <>
    <Helmet>
          <title>Patient portal | Patient</title>
        </Helmet>
        <Box component="div" m={1}>

        <CssBaseline />
        <Paper className={classes.paper}>
      
      <AppBar position="static" color="default" className={classes.root}>
        <Tabs
          value={this.state.tabsValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >
          <Tab label="Basic Info" {...a11yProps(0)}/>
          <Tab label="Address Info" {...a11yProps(1)} disabled={this.state.isNew?true:false}/>
          <Tab label="Insurance Info" {...a11yProps(2)}  disabled={this.state.isNew?true:false}/>
          <Tab label="Appointment History" {...a11yProps(3)}  disabled={this.state.isNew?true:false}/>
          
        </Tabs>
      </AppBar>
        
        <PatientTapPanel value={this.state.tabsValue} index={0}>
          {basicInfo}
        </PatientTapPanel>
        <PatientTapPanel value={this.state.tabsValue} index={1}>
          <PatientAddressInfo address={this.state.patient && this.state.patient.patientAddressDetails ? this.state.patient.patientAddressDetails :{}} updateAddressInfo={(value) => {updateAddressInfo(value)}}/>
        </PatientTapPanel>
        <PatientTapPanel value={this.state.tabsValue} index={2}>
          <PatientInsuranceInfo insInfo={this.state.patient?this.state.patient:{}} updateInsurerInfo={(value) => {updateInsurerInfo(value)}}/>
        </PatientTapPanel>
        <PatientTapPanel value={this.state.tabsValue} index={3}>
          
          <PatientAppointmentHistory showAddNewAppointment={false} isCalenderView={true} 
          patientId={this.props.user.userRole===USER_ROLE.PATIENT?this.props.user.patientId:this.state.patientId}/>
        </PatientTapPanel>
      </Paper>
        </Box>
      </>
  );
}
}


function mapStateToProps(state) {
  const  user  = state.authentication.user;
  const patient = state.patient;
  return { user , patient};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUserById: (id) => {
      dispatch(PatientActions.getPatientById(id));
    },submit: (value) => {
      dispatch(PatientActions.register(value));
    },update: (value) => {
      dispatch(PatientActions.updateProfile(value));
    },updateAddressInfo: (value) => {
      dispatch(PatientActions.updateAddressInfo(value));
    },updateInsuranceInfo: (value) => {
      dispatch(PatientActions.updateInsuranceInfo(value));
    },addNew : () =>{
      dispatch(PatientActions.addNewPatient());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles,{ withTheme: true })(PatientProfile));